export const postAddToCart = async (variantId, frequencyId) => {
  if (!variantId) return;

  if (
    window.cartConfig?.limit_free_gift &&
    window.cartConfig.free_gift_available_variant_id
  ) {
    if (
      String(variantId) ===
      String(window.cartConfig.free_gift_available_variant_id)
    ) {
      alert('Sorry, this product is not available for direct sale.');
      return;
    }
  }

  const payload = {
    id: parseInt(variantId),
    quantity: 1,
  };
  if (frequencyId) payload.selling_plan = parseInt(frequencyId);
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error('Failed to add product to cart');
    }

    await window.CartDrawer?.fetch?.();
    window.CartDrawer?.show?.(false);

    return await response.json();
  } catch (error) {
    console.error('Error adding to cart:', error);
  }
};
